import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Avatar from '../components/Avatar';

const emptyForm = { username: '', fullName: '', email: '', companyId: '', role: 'MEMBER', password: '', apps: '' };
const APP_OPTIONS = [
  { key: 'devops', label: 'DevOps Center' },
  { key: 'pm', label: 'PM Center' },
  { key: 'support', label: 'Support Center' },
  { key: 'products', label: 'CLTS Products' },
];

export default function Users() {
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState('');

  const load = () => {
    api.get('/users').then(r => setUsers(r.data)).catch(() => {});
    api.get('/companies').then(r => setCompanies(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const getCompanyName = (id) => {
    const c = companies.find(c => c.id === id);
    return c ? c.name : '-';
  };

  const openNew = () => {
    setForm(emptyForm); setEditing(null); setShowForm(true); setError('');
  };

  const hasApp = (key) => (form.apps || '').split(',').map(s => s.trim()).includes(key);
  const toggleApp = (key) => {
    const set = new Set((form.apps || '').split(',').map(s => s.trim()).filter(Boolean));
    if (set.has(key)) set.delete(key); else set.add(key);
    setForm({ ...form, apps: Array.from(set).join(',') });
  };

  const openEdit = (u) => {
    setForm({ username: u.username, fullName: u.fullName, email: u.email || '', companyId: u.companyId || '', role: u.role, password: '', apps: u.apps || '' });
    setEditing(u); setShowForm(true); setError('');
  };

  const save = async () => {
    setError('');
    if (!form.username || !form.fullName) { setError('Username and Full Name are required'); return; }
    if (!form.companyId) { setError('Company is required'); return; }
    try {
      if (editing) {
        await api.put(`/users/${editing.id}`, {
          fullName: form.fullName, email: form.email, role: form.role,
          companyId: form.companyId ? String(form.companyId) : '', apps: form.apps,
          ...(form.password ? { password: form.password } : {})
        });
      } else {
        await api.post('/users', form);
      }
      setShowForm(false); setEditing(null); setForm(emptyForm); load();
    } catch (e) { setError(e.response?.data?.error || 'Failed'); }
  };

  const resetPwd = async (id) => {
    if (!window.confirm('Reset password to Welcome@123?')) return;
    await api.post(`/users/${id}/reset-password`);
    alert('Password reset to Welcome@123');
  };

  const toggleActive = async (u) => {
    await api.put(`/users/${u.id}`, { active: String(!u.active) });
    load();
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#0f172a' }}>Users</h2>
        <button className="btn-primary" onClick={openNew}>+ Add User</button>
      </div>

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 32, width: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <h3 style={{ fontWeight: 700, marginBottom: 20, color: '#0f172a' }}>{editing ? 'Edit User' : 'Add User'}</h3>
            {error && <div style={{ background: '#fee2e2', color: '#b91c1c', borderRadius: 8, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>{error}</div>}
            <div style={{ display: 'grid', gap: 12 }}>
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>Company *</label>
                <select value={form.companyId} onChange={e => setForm({ ...form, companyId: e.target.value })}>
                  <option value="">Select Company</option>
                  {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>Username *</label>
                <input value={form.username} onChange={e => setForm({ ...form, username: e.target.value })}
                  disabled={!!editing} style={{ opacity: editing ? 0.6 : 1 }} />
              </div>
              <div><label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>Full Name *</label><input value={form.fullName} onChange={e => setForm({ ...form, fullName: e.target.value })} /></div>
              <div><label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>Email</label><input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} /></div>
              <div><label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>Role</label>
                <select value={form.role} onChange={e => setForm({ ...form, role: e.target.value })}>
                  <option value="ADMIN">Admin</option><option value="PM">Project Manager</option><option value="TEAM_LEAD">Team Lead</option><option value="DEVELOPER">Developer</option><option value="MEMBER">Member</option>
                </select>
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4 }}>
                  {editing ? 'New Password (leave blank to keep)' : 'Password'}
                </label>
                <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                  placeholder={editing ? 'Leave blank to keep current' : 'Default: Welcome@123'} />
              </div>
              {editing && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <label style={{ fontSize: 13, fontWeight: 500 }}>Active</label>
                  <input type="checkbox" checked={form.active !== false} onChange={e => setForm({ ...form, active: e.target.checked })} />
                </div>
              )}
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 6 }}>App Access</label>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {APP_OPTIONS.map(a => {
                    const on = hasApp(a.key);
                    return (
                      <button type="button" key={a.key} onClick={() => toggleApp(a.key)} style={{
                        display: 'inline-flex', alignItems: 'center', gap: 6, padding: '6px 14px',
                        borderRadius: 999, fontSize: 13, fontWeight: 500, cursor: 'pointer', transition: 'all 0.15s',
                        border: on ? '1px solid var(--primary, #4f46e5)' : '1px solid #d1d5db',
                        background: on ? 'var(--primary, #4f46e5)' : '#fff',
                        color: on ? '#fff' : '#374151',
                      }}>
                        {on ? '✓' : '+'} {a.label}
                      </button>
                    );
                  })}
                </div>
                <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
                  Leave all off to grant access to all apps. ADMIN always has full access.
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 20 }}>
              <button className="btn-primary" onClick={save} style={{ flex: 1 }}>{editing ? 'Update' : 'Create'}</button>
              <button className="btn-ghost" onClick={() => { setShowForm(false); setEditing(null); }} style={{ flex: 1 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <table>
          <thead><tr><th>Username</th><th>Full Name</th><th>Company</th><th>Email</th><th>Role</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                <td style={{ fontWeight: 600 }}>{u.username}</td>
                <td><span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}><Avatar name={u.fullName} size={24} fontSize={10} /> {u.fullName}</span></td>
                <td>{getCompanyName(u.companyId)}</td>
                <td style={{ color: '#6b7280' }}>{u.email || '-'}</td>
                <td><span className="badge badge-info">{u.role}</span></td>
                <td><span className={`badge ${u.active ? 'badge-success' : 'badge-danger'}`}>{u.active ? 'Active' : 'Disabled'}</span></td>
                <td>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <button className="btn-ghost" onClick={() => openEdit(u)} style={{ padding: '4px 10px', fontSize: 12 }}>Edit</button>
                    <button className="btn-ghost" onClick={() => resetPwd(u.id)} style={{ padding: '4px 10px', fontSize: 12 }}>Reset</button>
                    <button className="btn-ghost" onClick={() => toggleActive(u)} style={{ padding: '4px 10px', fontSize: 12, color: u.active ? '#dc2626' : '#059669' }}>{u.active ? 'Disable' : 'Enable'}</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
